module.exports = __webpack_public_path__ + "img/Icon-sign-in-alt-solid.604ad6a4.jpg";